const mmCssAnimation = {
    boxShadow: (color, opacity) => `1px 1px 32px 16px ${mmConfig.color[color].replace('1)', opacity)}`,

    boxShadowBlock: (color, opacity) => `
        box-shadow: ${mmCssAnimation.boxShadow(color, opacity)};
        -webkit-box-shadow: ${mmCssAnimation.boxShadow(color, opacity)};
        -moz-box-shadow: ${mmCssAnimation.boxShadow(color, opacity)};
    `,

    animationClass: (name) => `
        .${name}-animation {
            animation-name: ${name}-animation;
            animation-duration: ${mmConfig.animation.animationDuration};
            animation-iteration-count: ${mmConfig.animation.animationIterationCount};
            animation-direction: ${mmConfig.animation.animationDirection};
            animation-timing-function: ${mmConfig.animation.animationTimingFunction};
        }
    `,

    generateColorAnimation: (color) => {
        const styleElement = document.querySelector('style');
        styleElement.innerHTML += `
            @keyframes ${color}-animation {
                0% { ${mmCssAnimation.boxShadowBlock(color, '0.3)')} }
                50% { background-color: ${mmConfig.color[color].replace('1)', '0.7)')}; ${mmCssAnimation.boxShadowBlock(color, '0.6)')} }
                100% { ${mmCssAnimation.boxShadowBlock(color, '0.3)')} }
            }
            ${mmCssAnimation.animationClass(color)}
        `;
    },

    generateScaleAnimation: (name) => {
        const styleElement = document.querySelector('style');
        styleElement.innerHTML += `
            @keyframes ${name}-animation {
                0% {}
                50% { transform: scale(1.7); }
                100% {}
            }
            ${mmCssAnimation.animationClass(name)}
        `;
    },

    addClassToElement: (element, color) => {
        element.classList.add(`${color}-animation`);
    },
};

const mmConfig = {
    animation: {
        baseColor: 'rgba(255, 0, 0, 1)',
        opacity: 0.3,
        animationDuration: '12s',
        animationIterationCount: 'infinite',
        animationDirection: 'normal',
        animationTimingFunction: 'ease-in-out',
    },
    color: {
        red: 'rgba(255, 0, 0, 1)',
        green: 'rgba(0, 255, 0, 1)',
        blue: 'rgba(0, 0, 255, 1)',
        white: 'rgba(255, 255, 255, 1)',
        black: 'rgba(0, 0, 0, 1)',
    },
    attributes: {
        type: {
            line: {
                width: '100%',
                height: '25%',
                display: 'flex',
                justifyContent: 'space-between',
            },
            yin: {
                width: '100%',
                height: '100%',
            },
            yang: {
                width: '45%',
                height: '100%',
            },
            trigram: {
                aspectRatio: '2/1',
                height: '40%',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexFlow: 'column wrap',
            },
            hexagram: {
                width: '50%',
                height: '50%',
                display: 'flex',
                alignItems: 'center',
                flexFlow: 'column',
                justifyContent: 'space-between',
            },
        },
        color: {
            red: {
                border: '1px solid rgb(255, 0, 0)',
                background: 'rgb(255, 0, 0, 0.2)',
                boxShadow: '1px 1px 32px 16px rgb(255, 0, 0, 0.3)',
            },
            green: {
                border: '1px solid rgb(0, 255, 0)',
                background: 'rgb(0, 255, 0, 0.2)',
                boxShadow: '1px 1px 32px 16px rgb(0, 255, 0, 0.3)',
            },
            blue: {
                border: '1px solid rgb(0, 0, 255)',
                background: 'rgb(0, 0, 255, 0.2)',
                boxShadow: '1px 1px 32px 16px rgb(0, 0, 255, 0.3)',
            },
            white: {
                border: '1px solid rgba(255, 255, 255, 0.4)',
                background: 'rgb(255, 255, 255, 0.2)',
                boxShadow: '1px 1px 32px 16px rgb(255, 255, 255, 0.2)',
            },
            white1: {
                border: '1px solid rgba(255, 255, 255, 0.4)',
                background: 'rgb(255, 255, 255, 0.4)',
                boxShadow: '1px 1px 32px 16px rgb(255, 255, 255, 0.2)',
            },
            white2: {
                border: '1px solid rgba(255, 255, 255, 0.4)',
                background: 'rgb(255, 255, 255, 0.6)',
                boxShadow: '1px 1px 32px 16px rgb(255, 255, 255, 0.2)',
            },
            black: {
                border: '1px solid rgb(0, 0, 0)',
                background: 'rgb(0, 0, 0, 0.2)',
                boxShadow: '1px 1px 32px 16px rgb(0, 0, 0, 0.3)',
            },
        }
    },
};

const mmYinyang = {
    name: 'mmYinyang',
    index: 0,
    createElement: (name, type, color) => {
        const el = document.createElement("div");
        el.setAttribute('id', name);
        Object.assign(el.style, mmConfig.attributes.type[type]);
        if (type === 'line') {
            el.classList.add('line-animation');
        } else {
            Object.assign(el.style, mmConfig.attributes.color[color]);
            el.classList.add(`${color}-animation`);
        }
        el.style.animationDelay = `${mmYinyang.index * 0.5}s`;
        return el;
    },

    generateLine: (yytype, nameExt, color, index) => {
        mmYinyang.name = `${yytype}${nameExt}`;
        mmYinyang.index = index;

        const elLine = mmYinyang.createElement(`line${index}`, 'line', 'black', index);

        if (yytype === 'yin') {
            const elYin = mmYinyang.createElement(mmYinyang.name, 'yin', color, index);
            elLine.appendChild(elYin);
        }

        if (yytype === 'yang') {
            const elYang1 = mmYinyang.createElement(mmYinyang.name, 'yang', color, index);
            elLine.appendChild(elYang1);

            const elYang2 = mmYinyang.createElement(mmYinyang.name, 'yang', color, index);
            elLine.appendChild(elYang2);
        }
        return elLine;
    },

    generateTrigram: (index, type, rgb) => {
        const trigram = document.createElement("div");
        trigram.setAttribute('id', `trigram${index}`);
        Object.assign(trigram.style, mmConfig.attributes.type['trigram']);

        const lines = {
            heaven: ['yin', 'yin', 'yin'],
            lake: ['yang', 'yin', 'yin'],
            flame: ['yin', 'yang', 'yin'],
            thunder: ['yang', 'yang', 'yin'],
            wind: ['yin', 'yin', 'yang'],
            water: ['yang', 'yin', 'yang'],
            mountain: ['yin', 'yang', 'yang'],
            earth: ['yang', 'yang', 'yang'],
        }[type];

        const colors = (rgb === 'rgb') ? ['red', 'green', 'blue'] : ['white', 'white1', 'white2'];

        lines.forEach((line, i) => {
            const lineElement = mmYinyang.generateLine(line, i, colors[i], index + i);
            trigram.appendChild(lineElement);
        });

        return trigram;
    },

    generateHexaGram: (trigram1, trigram2, index, rgb) => {
        const hexagram = document.createElement("div");
        hexagram.setAttribute('id', 'hexagram');
        Object.assign(hexagram.style, mmConfig.attributes.type['hexagram']);
        hexagram.appendChild(mmYinyang.generateTrigram(index, trigram1, rgb));
        hexagram.appendChild(mmYinyang.generateTrigram(index + 3, trigram2, rgb));
        return hexagram;
    }
};

function mmBootstrap(container, trigram1, trigram2, index, rgb) {
    Object.assign(container.style, {
        width: '100%',
        height: '100%',
        padding: '0',
        margin: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexFlow: 'column wrap',
    });
    container.classList.add('mmContainer');
    container.appendChild(mmYinyang.generateHexaGram(trigram1, trigram2, index, rgb));
}